/**
 * Main Theme JavaScript
 * Initialize global functionality and event handlers
 */

const NCMARaleighTheme = {
  init: function() {
    console.log('NCMA Raleigh Theme initialized');

    this.setupSmoothScroll();
    this.setupAccessibility();
    this.handleResize();
    this.setupStickyHeader();
  },

  setupStickyHeader: function() {
    const header = document.querySelector('.site-header');
    if (!header) return;

    const sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    header.insertAdjacentElement('afterend', sentinel);

    const observer = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle('is-sticky', !entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  },

  /**
   * Setup smooth scrolling for anchor links
   */
  setupSmoothScroll: function() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');
    
    anchorLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          e.preventDefault();
          const headerOffset = 80; // Adjust based on your fixed header height
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  },

  /**
   * Accessibility enhancements
   */
  setupAccessibility: function() {
    // Add focus-visible support for better keyboard navigation
    document.body.addEventListener('keydown', (e) => {
      if (e.key === 'Tab') {
        document.body.classList.add('user-is-tabbing');
      }
    });

    document.body.addEventListener('mousedown', () => {
      document.body.classList.remove('user-is-tabbing');
    });

    // Skip to content link
    const skipLink = document.querySelector('.skip-link');
    if (skipLink) {
      skipLink.addEventListener('click', (e) => {
        const target = document.querySelector(skipLink.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.setAttribute('tabindex', '-1');
          target.focus();
        }
      });
    }
  },

  /**
   * Handle window resize events
   */
  handleResize: function() {
    const handleResizeEvent = NCMARaleighUtils.debounce(() => {
      const breakpoint = NCMARaleighUtils.getCurrentBreakpoint();
      document.body.setAttribute('data-breakpoint', breakpoint);
      
      // Add any resize-specific logic here
    }, 250);

    window.addEventListener('resize', handleResizeEvent);
    
    // Set initial breakpoint
    document.body.setAttribute('data-breakpoint', NCMARaleighUtils.getCurrentBreakpoint());
  }
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => NCMARaleighTheme.init());
} else {
  NCMARaleighTheme.init();
}

// Make theme object available globally for console debugging if needed
window.NCMARaleighTheme = NCMARaleighTheme;
